// updated sentech endpoints --comment for usage
// export const endpoint = {
//   /* AUTH APIS */
//   SIGN_IN_ENDPOINT:
//     "https://tjj58pyh99.execute-api.eu-west-1.amazonaws.com/dev/signin",
//   REGISTER_ENDPOINT:
//     "https://tjj58pyh99.execute-api.eu-west-1.amazonaws.com/dev/register",
//   CONFIRM_REGISTRATION_ENDPOINT:
//     "https://tjj58pyh99.execute-api.eu-west-1.amazonaws.com/dev/confirmregistration",
//   RESEND_OTP_ENDPOINT:
//     "https://tjj58pyh99.execute-api.eu-west-1.amazonaws.com/dev/resendotp",
//   FORGOT_PASSWORD_ENDPOINT:
//     "https://tjj58pyh99.execute-api.eu-west-1.amazonaws.com/dev/forgotpassword",
//   RESET_PASSWORD_ENDPOINT:
//     "https://tjj58pyh99.execute-api.eu-west-1.amazonaws.com/dev/resetpassword",
//   SIGNOUT:
//     "https://tjj58pyh99.execute-api.eu-west-1.amazonaws.com/dev/signout",
//   REFRESH_ENDPOINT:
//     "https://tjj58pyh99.execute-api.eu-west-1.amazonaws.com/dev/refreshtoken",
//   // USER API
//   GET_USER_ENDPOINT:
//     "https://og6gv8i8y5.execute-api.eu-west-1.amazonaws.com/dev/get",
//   EDIT_USER_ENDPOINT:
//     "https://og6gv8i8y5.execute-api.eu-west-1.amazonaws.com/dev/edit",
//   DELETE_USER_ENDPOINT:
//     "https://og6gv8i8y5.execute-api.eu-west-1.amazonaws.com/dev/delete",
//   // USER MANAGEMENT API
//   ADMIN_LIST_USER_ENDPOINT:
//     "https://h7lqlynor5.execute-api.eu-west-1.amazonaws.com/dev/list", 
//   ADMIN_ADD_USER_ENDPOINT:
//     "https://h7lqlynor5.execute-api.eu-west-1.amazonaws.com/dev/add",
//   ADMIN_EDIT_USER_ENDPOINT:
//     "https://h7lqlynor5.execute-api.eu-west-1.amazonaws.com/dev/edit", 
//   ADMIN_DELET_USER_ENDPOINT:
//     "https://h7lqlynor5.execute-api.eu-west-1.amazonaws.com/dev/delete", 
//   // TENDER API
//   LIST_PUBLIC_ENDPOINT:
//     "https://4rf016lqxj.execute-api.eu-west-1.amazonaws.com/dev/listpublic",
//   LIST_PRIVATE_ENDPOINT:
//     "https://4rf016lqxj.execute-api.eu-west-1.amazonaws.com/dev/listprivate",
//   LIST_MYTENDER_ENDPOINT:
//     "https://4rf016lqxj.execute-api.eu-west-1.amazonaws.com/dev/listmytender",
//   GET_TENDER_ENDPOINT:
//     "https://4rf016lqxj.execute-api.eu-west-1.amazonaws.com/dev/gettender",  
//   ADMIN_LIST_TEDNERS:
//     "https://4rf016lqxj.execute-api.eu-west-1.amazonaws.com/dev/listtender",  
//   // TENDER RESPONSE API
//   RESPOND_ENDPOINT:
//     "https://wzl22988hk.execute-api.eu-west-1.amazonaws.com/dev/respond",
//   UPLOAD_SUBMISSION_FILE_ENDPOINT:
//     "https://wzl22988hk.execute-api.eu-west-1.amazonaws.com/dev/uploadsubmissionfile",
//   GET_FILE_ENDPOINT:
//     "https://wzl22988hk.execute-api.eu-west-1.amazonaws.com/dev/getfile",
//   DELETE_FILE_ENDPOINT:
//     "https://wzl22988hk.execute-api.eu-west-1.amazonaws.com/dev/deletefile",
//   SAVE_SUBMISSION_ENDPOINT:
//     "https://wzl22988hk.execute-api.eu-west-1.amazonaws.com/dev/savesubmission",
//   DELETE_RESPONSE_ENDPOINT:
//     "https://wzl22988hk.execute-api.eu-west-1.amazonaws.com/dev/deleteresponse",
//   // TENDER MANAGEMENT API
//   ADD_TENDER: "https://7cfrvfv96c.execute-api.eu-west-1.amazonaws.com/dev/add",
//   LIST_CATEGORIES:
//     "https://7cfrvfv96c.execute-api.eu-west-1.amazonaws.com/dev/ListCategories",
//   EDIT_TENDER:
//     "https://7cfrvfv96c.execute-api.eu-west-1.amazonaws.com/dev/edit",
//   DELETE_TENDER:
//     "https://7cfrvfv96c.execute-api.eu-west-1.amazonaws.com/dev/delete",
//   UPDATE_TENDER_FILE:
//     "https://7cfrvfv96c.execute-api.eu-west-1.amazonaws.com/dev/updatefile",
//   ASSIGN_TENDER:
//     "https://7cfrvfv96c.execute-api.eu-west-1.amazonaws.com/dev/assign",
//   REMOVE_USER_TENDER:
//     "https://7cfrvfv96c.execute-api.eu-west-1.amazonaws.com/dev/remove",
//   INVITE_BIDDER:
//     "https://7cfrvfv96c.execute-api.eu-west-1.amazonaws.com/dev/invite",
//   BIDDER_DECLINE:
//     "https://7cfrvfv96c.execute-api.eu-west-1.amazonaws.com/dev/decline",
//   UPDATE_MESSAGE:
//     "https://7cfrvfv96c.execute-api.eu-west-1.amazonaws.com/dev/updatemessage",
//   //Submission review
//   LIST_SUBMISSIONS:
//     "https://8aurd51826.execute-api.eu-west-1.amazonaws.com/dev/listsubmissions",
//   GET_SUBMISSION:
//     "https://8aurd51826.execute-api.eu-west-1.amazonaws.com/dev/getsubmission",
//   GET_SUBMISSION_FILE:
//     "https://8aurd51826.execute-api.eu-west-1.amazonaws.com/dev/getsubmissionfile",
//   //Reporting
//   ACCESS_LOGS:
//     "https://3u7ldx7zjd.execute-api.eu-west-1.amazonaws.com/dev/accesslogs",
//   SUBMISSION_REPORT:
//     "https://3u7ldx7zjd.execute-api.eu-west-1.amazonaws.com/dev/submissionreport",

//   WEBSOCKET: 
//   // "wss://4dpyn70ho9.execute-api.eu-west-1.amazonaws.com/prod", 
//     "wss://lda5uunyp7.execute-api.eu-west-1.amazonaws.com/prod",
// };


// // updated aizatron endpoints --comment for usage
export const endpoint = {
  /* AUTH APIS */
  SIGN_IN_ENDPOINT:
    "https://nzmc4wu44h.execute-api.us-west-2.amazonaws.com/dev/signin",
  REGISTER_ENDPOINT:
    "https://nzmc4wu44h.execute-api.us-west-2.amazonaws.com/dev/register",
  CONFIRM_REGISTRATION_ENDPOINT:
    "https://nzmc4wu44h.execute-api.us-west-2.amazonaws.com/dev/confirmregistration",
  RESEND_OTP_ENDPOINT:
    "https://nzmc4wu44h.execute-api.us-west-2.amazonaws.com/dev/resendotp",
  FORGOT_PASSWORD_ENDPOINT:
    "https://nzmc4wu44h.execute-api.us-west-2.amazonaws.com/dev/forgotpassword",
  RESET_PASSWORD_ENDPOINT:
    "https://nzmc4wu44h.execute-api.us-west-2.amazonaws.com/dev/resetpassword",
  SIGNOUT:
    "https://nzmc4wu44h.execute-api.us-west-2.amazonaws.com/dev/signout",
  REFRESH_ENDPOINT:
    "https://nzmc4wu44h.execute-api.us-west-2.amazonaws.com/dev/refreshtoken",
  // USER API
  GET_USER_ENDPOINT:
    "https://c0mvagu3s6.execute-api.us-west-2.amazonaws.com/dev/get",
  EDIT_USER_ENDPOINT:
    "https://c0mvagu3s6.execute-api.us-west-2.amazonaws.com/dev/edit",
  DELETE_USER_ENDPOINT:
    "https://c0mvagu3s6.execute-api.us-west-2.amazonaws.com/dev/delete",
  // USER MANAGEMENT API
  ADMIN_LIST_USER_ENDPOINT:
    "https://859lopr9hg.execute-api.us-west-2.amazonaws.com/dev/list", 
  ADMIN_ADD_USER_ENDPOINT:
    "https://859lopr9hg.execute-api.us-west-2.amazonaws.com/dev/add",
  ADMIN_EDIT_USER_ENDPOINT:
    "https://859lopr9hg.execute-api.us-west-2.amazonaws.com/dev/edit", 
  ADMIN_DELET_USER_ENDPOINT:
    "https://859lopr9hg.execute-api.us-west-2.amazonaws.com/dev/delete", 
  // TENDER API
  LIST_PUBLIC_ENDPOINT:
    "https://sy08zt64l6.execute-api.us-west-2.amazonaws.com/dev/listpublic",
  LIST_PRIVATE_ENDPOINT:
    "https://sy08zt64l6.execute-api.us-west-2.amazonaws.com/dev/listprivate",
  LIST_MYTENDER_ENDPOINT:
    "https://sy08zt64l6.execute-api.us-west-2.amazonaws.com/dev/listmytender",
  GET_TENDER_ENDPOINT:
    "https://sy08zt64l6.execute-api.us-west-2.amazonaws.com/dev/gettender",  
  ADMIN_LIST_TEDNERS:
    "https://sy08zt64l6.execute-api.us-west-2.amazonaws.com/dev/listtender",  
  // TENDER RESPONSE API
  RESPOND_ENDPOINT:
    "https://iu6244z96j.execute-api.us-west-2.amazonaws.com/dev/respond",
  UPLOAD_SUBMISSION_FILE_ENDPOINT:
    "https://iu6244z96j.execute-api.us-west-2.amazonaws.com/dev/uploadsubmissionfile",
  GET_FILE_ENDPOINT:
    "https://iu6244z96j.execute-api.us-west-2.amazonaws.com/dev/getfile",
  DELETE_FILE_ENDPOINT:
    "https://iu6244z96j.execute-api.us-west-2.amazonaws.com/dev/deletefile",
  SAVE_SUBMISSION_ENDPOINT:
    "https://iu6244z96j.execute-api.us-west-2.amazonaws.com/dev/savesubmission",
  DELETE_RESPONSE_ENDPOINT:
    "https://iu6244z96j.execute-api.us-west-2.amazonaws.com/dev/deleteresponse",
  // TENDER MANAGEMENT API
  ADD_TENDER: "https://0je4ig1615.execute-api.us-west-2.amazonaws.com/dev/add",
  LIST_CATEGORIES:
    "https://0je4ig1615.execute-api.us-west-2.amazonaws.com/dev/ListCategories",
  EDIT_TENDER:
    "https://0je4ig1615.execute-api.us-west-2.amazonaws.com/dev/edit",
  DELETE_TENDER:
    "https://0je4ig1615.execute-api.us-west-2.amazonaws.com/dev/delete",
  UPDATE_TENDER_FILE:
    "https://0je4ig1615.execute-api.us-west-2.amazonaws.com/dev/updatefile",
  ASSIGN_TENDER:
    "https://0je4ig1615.execute-api.us-west-2.amazonaws.com/dev/assign",
  REMOVE_USER_TENDER:
    "https://0je4ig1615.execute-api.us-west-2.amazonaws.com/dev/remove",
  INVITE_BIDDER:
    "https://0je4ig1615.execute-api.us-west-2.amazonaws.com/dev/invite",
  BIDDER_DECLINE:
    "https://0je4ig1615.execute-api.us-west-2.amazonaws.com/dev/decline",
  UPDATE_MESSAGE:
    "https://0je4ig1615.execute-api.us-west-2.amazonaws.com/dev/updatemessage",
  //Submission review
  LIST_SUBMISSIONS:
    "https://u29gfjl9ga.execute-api.us-west-2.amazonaws.com/dev/listsubmissions",
  GET_SUBMISSION:
    "https://u29gfjl9ga.execute-api.us-west-2.amazonaws.com/dev/getsubmission",
  GET_SUBMISSION_FILE:
    "https://u29gfjl9ga.execute-api.us-west-2.amazonaws.com/dev/getsubmissionfile",
  //Reporting
  ACCESS_LOGS:
    "https://ni3n9e3kec.execute-api.us-west-2.amazonaws.com/dev/accesslogs",
  SUBMISSION_REPORT:
    "https://ni3n9e3kec.execute-api.us-west-2.amazonaws.com/dev/submissionreport",

  WEBSOCKET: 
  // "wss://4dpyn70ho9.execute-api.eu-west-1.amazonaws.com/prod", 
    // "wss://rbe6rmrfoj.execute-api.us-west-2.amazonaws.com/prod",
    "wss://lubf4xbjt1.execute-api.us-west-2.amazonaws.com/prod",
};

// updated sentech prod endpoints --comment for usage
// export const endpoint = {
//   /* AUTH APIS */
//   SIGN_IN_ENDPOINT:
//     "https://qgc1sgdhj6.execute-api.af-south-1.amazonaws.com/dev/signin",
//   REGISTER_ENDPOINT:
//     "https://qgc1sgdhj6.execute-api.af-south-1.amazonaws.com/dev/register",
//   CONFIRM_REGISTRATION_ENDPOINT:
//     "https://qgc1sgdhj6.execute-api.af-south-1.amazonaws.com/dev/confirmregistration",
//   RESEND_OTP_ENDPOINT:
//     "https://qgc1sgdhj6.execute-api.af-south-1.amazonaws.com/dev/resendotp",
//   FORGOT_PASSWORD_ENDPOINT:
//     "https://qgc1sgdhj6.execute-api.af-south-1.amazonaws.com/dev/forgotpassword",
//   RESET_PASSWORD_ENDPOINT:
//     "https://qgc1sgdhj6.execute-api.af-south-1.amazonaws.com/dev/resetpassword",
//   SIGNOUT:
//     "https://qgc1sgdhj6.execute-api.af-south-1.amazonaws.com/dev/signout",
//   REFRESH_ENDPOINT:
//     "https://qgc1sgdhj6.execute-api.af-south-1.amazonaws.com/dev/refreshtoken",
//   // USER API
//   GET_USER_ENDPOINT:
//     "https://diouw4rvvj.execute-api.af-south-1.amazonaws.com/dev/get",
//   EDIT_USER_ENDPOINT:
//     "https://diouw4rvvj.execute-api.af-south-1.amazonaws.com/dev/edit",
//   DELETE_USER_ENDPOINT:
//     "https://diouw4rvvj.execute-api.af-south-1.amazonaws.com/dev/delete",
//   // USER MANAGEMENT API
//   ADMIN_LIST_USER_ENDPOINT:
//     "https://78ky8h27j9.execute-api.af-south-1.amazonaws.com/dev/list", 
//   ADMIN_ADD_USER_ENDPOINT:
//     "https://78ky8h27j9.execute-api.af-south-1.amazonaws.com/dev/add",
//   ADMIN_EDIT_USER_ENDPOINT:
//     "https://78ky8h27j9.execute-api.af-south-1.amazonaws.com/dev/edit", 
//   ADMIN_DELET_USER_ENDPOINT:
//     "https://78ky8h27j9.execute-api.af-south-1.amazonaws.com/dev/delete", 
//   // TENDER API
//   LIST_PUBLIC_ENDPOINT:
//     "https://k9m8gzgtwi.execute-api.af-south-1.amazonaws.com/dev/listpublic",
//   LIST_PRIVATE_ENDPOINT:
//     "https://k9m8gzgtwi.execute-api.af-south-1.amazonaws.com/dev/listprivate",
//   LIST_MYTENDER_ENDPOINT:
//     "https://k9m8gzgtwi.execute-api.af-south-1.amazonaws.com/dev/listmytender",
//   GET_TENDER_ENDPOINT:
//     "https://k9m8gzgtwi.execute-api.af-south-1.amazonaws.com/dev/gettender",  
//   ADMIN_LIST_TEDNERS:
//     "https://k9m8gzgtwi.execute-api.af-south-1.amazonaws.com/dev/listtender",  
//   // TENDER RESPONSE API
//   RESPOND_ENDPOINT:
//     "https://q3nxmxa43a.execute-api.af-south-1.amazonaws.com/dev/respond",
//   UPLOAD_SUBMISSION_FILE_ENDPOINT:
//     "https://q3nxmxa43a.execute-api.af-south-1.amazonaws.com/dev/uploadsubmissionfile",
//   GET_FILE_ENDPOINT:
//     "https://q3nxmxa43a.execute-api.af-south-1.amazonaws.com/dev/getfile",
//   DELETE_FILE_ENDPOINT:
//     "https://q3nxmxa43a.execute-api.af-south-1.amazonaws.com/dev/deletefile",
//   SAVE_SUBMISSION_ENDPOINT:
//     "https://q3nxmxa43a.execute-api.af-south-1.amazonaws.com/dev/savesubmission",
//   DELETE_RESPONSE_ENDPOINT:
//     "https://q3nxmxa43a.execute-api.af-south-1.amazonaws.com/dev/deleteresponse",
//   // TENDER MANAGEMENT API
//   ADD_TENDER: "https://olrqz9y9fc.execute-api.af-south-1.amazonaws.com/dev/add",
//   LIST_CATEGORIES:
//     "https://olrqz9y9fc.execute-api.af-south-1.amazonaws.com/dev/ListCategories",
//   EDIT_TENDER:
//     "https://olrqz9y9fc.execute-api.af-south-1.amazonaws.com/dev/edit",
//   DELETE_TENDER:
//     "https://olrqz9y9fc.execute-api.af-south-1.amazonaws.com/dev/delete",
//   UPDATE_TENDER_FILE:
//     "https://olrqz9y9fc.execute-api.af-south-1.amazonaws.com/dev/updatefile",
//   ASSIGN_TENDER:
//     "https://olrqz9y9fc.execute-api.af-south-1.amazonaws.com/dev/assign",
//   REMOVE_USER_TENDER:
//     "https://olrqz9y9fc.execute-api.af-south-1.amazonaws.com/dev/remove",
//   INVITE_BIDDER:
//     "https://olrqz9y9fc.execute-api.af-south-1.amazonaws.com/dev/invite",
//   BIDDER_DECLINE:
//     "https://olrqz9y9fc.execute-api.af-south-1.amazonaws.com/dev/decline",
//   UPDATE_MESSAGE:
//     "https://olrqz9y9fc.execute-api.af-south-1.amazonaws.com/dev/updatemessage",
//   //Submission review
//   LIST_SUBMISSIONS:
//     "https://quiwly7h0i.execute-api.af-south-1.amazonaws.com/dev/listsubmissions",
//   GET_SUBMISSION:
//     "https://quiwly7h0i.execute-api.af-south-1.amazonaws.com/dev/getsubmission",
//   GET_SUBMISSION_FILE:
//     "https://quiwly7h0i.execute-api.af-south-1.amazonaws.com/dev/getsubmissionfile",
//   //Reporting
//   ACCESS_LOGS:
//     "https://n7esgi6b10.execute-api.af-south-1.amazonaws.com/dev/accesslogs",
//   SUBMISSION_REPORT:
//     "https://n7esgi6b10.execute-api.af-south-1.amazonaws.com/dev/submissionreport",

//   WEBSOCKET: 
//     "wss://y68yc736w5.execute-api.af-south-1.amazonaws.com/prod",
// };

// sentech dev endpoints --comment for usage
// export const endpoint = {
//   /* AUTH APIS */
//   SIGN_IN_ENDPOINT:
//     "https://6198mhzc2a.execute-api.us-west-2.amazonaws.com/dev/signin",
//   REGISTER_ENDPOINT:
//     "https://6198mhzc2a.execute-api.us-west-2.amazonaws.com/dev/register",
//   CONFIRM_REGISTRATION_ENDPOINT:
//     "https://6198mhzc2a.execute-api.us-west-2.amazonaws.com/dev/confirmregistration",
//   RESEND_OTP_ENDPOINT:
//     "https://6198mhzc2a.execute-api.us-west-2.amazonaws.com/dev/resendotp",
//   FORGOT_PASSWORD_ENDPOINT:
//     "https://6198mhzc2a.execute-api.us-west-2.amazonaws.com/dev/forgotpassword",
//   RESET_PASSWORD_ENDPOINT:
//     "https://6198mhzc2a.execute-api.us-west-2.amazonaws.com/dev/resetpassword",
//   SIGNOUT:
//     "https://6198mhzc2a.execute-api.us-west-2.amazonaws.com/dev/signout",
//   REFRESH_ENDPOINT:
//     "https://6198mhzc2a.execute-api.us-west-2.amazonaws.com/dev/refreshtoken",
//   // USER API
//   GET_USER_ENDPOINT:
//     "https://xat07h7fyh.execute-api.us-west-2.amazonaws.com/dev/get",
//   EDIT_USER_ENDPOINT:
//     "https://xat07h7fyh.execute-api.us-west-2.amazonaws.com/dev/edit",
//   DELETE_USER_ENDPOINT:
//     "https://xat07h7fyh.execute-api.us-west-2.amazonaws.com/dev/delete",
//   // USER MANAGEMENT API
//   ADMIN_LIST_USER_ENDPOINT:
//     "https://odcsy70dc4.execute-api.us-west-2.amazonaws.com/dev/list", 
//   ADMIN_ADD_USER_ENDPOINT:
//     "https://odcsy70dc4.execute-api.us-west-2.amazonaws.com/dev/add",
//   ADMIN_EDIT_USER_ENDPOINT:
//     "https://odcsy70dc4.execute-api.us-west-2.amazonaws.com/dev/edit", 
//   ADMIN_DELET_USER_ENDPOINT:
//     "https://odcsy70dc4.execute-api.us-west-2.amazonaws.com/dev/delete", 
//   // TENDER API
//   LIST_PUBLIC_ENDPOINT:
//     "https://soq304zri3.execute-api.us-west-2.amazonaws.com/dev/listpublic",
//   LIST_PRIVATE_ENDPOINT:
//     "https://soq304zri3.execute-api.us-west-2.amazonaws.com/dev/listprivate",
//   LIST_MYTENDER_ENDPOINT:
//     "https://soq304zri3.execute-api.us-west-2.amazonaws.com/dev/listmytender",
//   GET_TENDER_ENDPOINT:
//     "https://soq304zri3.execute-api.us-west-2.amazonaws.com/dev/gettender",  
//   ADMIN_LIST_TEDNERS:
//     "https://soq304zri3.execute-api.us-west-2.amazonaws.com/dev/listtender",  
//   // TENDER RESPONSE API
//   RESPOND_ENDPOINT:
//     "https://9xxetupo0b.execute-api.us-west-2.amazonaws.com/dev/respond",
//   UPLOAD_SUBMISSION_FILE_ENDPOINT:
//     "https://9xxetupo0b.execute-api.us-west-2.amazonaws.com/dev/uploadsubmissionfile",
//   GET_FILE_ENDPOINT:
//     "https://9xxetupo0b.execute-api.us-west-2.amazonaws.com/dev/getfile",
//   DELETE_FILE_ENDPOINT:
//     "https://9xxetupo0b.execute-api.us-west-2.amazonaws.com/dev/deletefile",
//   SAVE_SUBMISSION_ENDPOINT:
//     "https://9xxetupo0b.execute-api.us-west-2.amazonaws.com/dev/savesubmission",
//   DELETE_RESPONSE_ENDPOINT:
//     "https://9xxetupo0b.execute-api.us-west-2.amazonaws.com/dev/deleteresponse",
//   // TENDER MANAGEMENT API
//   ADD_TENDER: "https://dnzjc54049.execute-api.us-west-2.amazonaws.com/dev/add",
//   LIST_CATEGORIES:
//     "https://dnzjc54049.execute-api.us-west-2.amazonaws.com/dev/ListCategories",
//   EDIT_TENDER:
//     "https://dnzjc54049.execute-api.us-west-2.amazonaws.com/dev/edit",
//   DELETE_TENDER:
//     "https://dnzjc54049.execute-api.us-west-2.amazonaws.com/dev/delete",
//   UPDATE_TENDER_FILE:
//     "https://dnzjc54049.execute-api.us-west-2.amazonaws.com/dev/updatefile",
//   ASSIGN_TENDER:
//     "https://dnzjc54049.execute-api.us-west-2.amazonaws.com/dev/assign",
//   REMOVE_USER_TENDER:
//     "https://dnzjc54049.execute-api.us-west-2.amazonaws.com/dev/remove",
//   INVITE_BIDDER:
//     "https://dnzjc54049.execute-api.us-west-2.amazonaws.com/dev/invite",
//   BIDDER_DECLINE:
//     "https://dnzjc54049.execute-api.us-west-2.amazonaws.com/dev/decline",
//   UPDATE_MESSAGE:
//     "https://dnzjc54049.execute-api.us-west-2.amazonaws.com/dev/updatemessage",
//   //Submission review
//   LIST_SUBMISSIONS:
//     "https://wc7yhswmea.execute-api.us-west-2.amazonaws.com/dev/listsubmissions",
//   GET_SUBMISSION:
//     "https://wc7yhswmea.execute-api.us-west-2.amazonaws.com/dev/getsubmission",
//   GET_SUBMISSION_FILE:
//     "https://wc7yhswmea.execute-api.us-west-2.amazonaws.com/dev/getsubmissionfile",
//   //Reporting
//   ACCESS_LOGS:
//     "https://w7eez5dx9a.execute-api.us-west-2.amazonaws.com/dev/accesslogs",
//   SUBMISSION_REPORT:
//     "https://w7eez5dx9a.execute-api.us-west-2.amazonaws.com/dev/submissionreport",
//   // Websocket
//   WEBSOCKET: 
//     "wss://i9iyqy9a00.execute-api.us-west-2.amazonaws.com/prod",
// };

// sentech qa endpoints --comment for usage
// export const endpoint = {
//   /* AUTH APIS */
//   SIGN_IN_ENDPOINT:
//     "https://0zbzi0iu72.execute-api.eu-west-1.amazonaws.com/dev/signin",
//   REGISTER_ENDPOINT:
//     "https://0zbzi0iu72.execute-api.eu-west-1.amazonaws.com/dev/register",
//   CONFIRM_REGISTRATION_ENDPOINT:
//     "https://0zbzi0iu72.execute-api.eu-west-1.amazonaws.com/dev/confirmregistration",
//   RESEND_OTP_ENDPOINT:
//     "https://0zbzi0iu72.execute-api.eu-west-1.amazonaws.com/dev/resendotp",
//   FORGOT_PASSWORD_ENDPOINT:
//     "https://0zbzi0iu72.execute-api.eu-west-1.amazonaws.com/dev/forgotpassword",
//   RESET_PASSWORD_ENDPOINT:
//     "https://0zbzi0iu72.execute-api.eu-west-1.amazonaws.com/dev/resetpassword",
//   SIGNOUT:
//     "https://0zbzi0iu72.execute-api.eu-west-1.amazonaws.com/dev/signout",
//   REFRESH_ENDPOINT:
//     "https://0zbzi0iu72.execute-api.eu-west-1.amazonaws.com/dev/refreshtoken",
//   // USER API
//   GET_USER_ENDPOINT:
//     "https://5rj3zqia26.execute-api.eu-west-1.amazonaws.com/dev/get",
//   EDIT_USER_ENDPOINT:
//     "https://5rj3zqia26.execute-api.eu-west-1.amazonaws.com/dev/edit",
//   DELETE_USER_ENDPOINT:
//     "https://5rj3zqia26.execute-api.eu-west-1.amazonaws.com/dev/delete",
//   // USER MANAGEMENT API
//   ADMIN_LIST_USER_ENDPOINT:
//     "https://d0r3szp1id.execute-api.eu-west-1.amazonaws.com/dev/list", 
//   ADMIN_ADD_USER_ENDPOINT:
//     "https://d0r3szp1id.execute-api.eu-west-1.amazonaws.com/dev/add",
//   ADMIN_EDIT_USER_ENDPOINT:
//     "https://d0r3szp1id.execute-api.eu-west-1.amazonaws.com/dev/edit", 
//   ADMIN_DELET_USER_ENDPOINT:
//     "https://d0r3szp1id.execute-api.eu-west-1.amazonaws.com/dev/delete", 
//   // TENDER API
//   LIST_PUBLIC_ENDPOINT:
//     "https://o28aeljcfc.execute-api.eu-west-1.amazonaws.com/dev/listpublic",
//   LIST_PRIVATE_ENDPOINT:
//     "https://o28aeljcfc.execute-api.eu-west-1.amazonaws.com/dev/listprivate",
//   LIST_MYTENDER_ENDPOINT:
//     "https://o28aeljcfc.execute-api.eu-west-1.amazonaws.com/dev/listmytender",
//   GET_TENDER_ENDPOINT:
//     "https://o28aeljcfc.execute-api.eu-west-1.amazonaws.com/dev/gettender",  
//   ADMIN_LIST_TEDNERS:
//     "https://o28aeljcfc.execute-api.eu-west-1.amazonaws.com/dev/listtender",  
//   // TENDER RESPONSE API
//   RESPOND_ENDPOINT:
//     "https://5r1h980btl.execute-api.eu-west-1.amazonaws.com/dev/respond",
//   UPLOAD_SUBMISSION_FILE_ENDPOINT:
//     "https://5r1h980btl.execute-api.eu-west-1.amazonaws.com/dev/uploadsubmissionfile",
//   GET_FILE_ENDPOINT:
//     "https://5r1h980btl.execute-api.eu-west-1.amazonaws.com/dev/getfile",
//   DELETE_FILE_ENDPOINT:
//     "https://5r1h980btl.execute-api.eu-west-1.amazonaws.com/dev/deletefile",
//   SAVE_SUBMISSION_ENDPOINT:
//     "https://5r1h980btl.execute-api.eu-west-1.amazonaws.com/dev/savesubmission",
//   DELETE_RESPONSE_ENDPOINT:
//     "https://5r1h980btl.execute-api.eu-west-1.amazonaws.com/dev/deleteresponse",
//   // TENDER MANAGEMENT API
//   ADD_TENDER: "https://3ldx476lsa.execute-api.eu-west-1.amazonaws.com/dev/add",
//   LIST_CATEGORIES:
//     "https://3ldx476lsa.execute-api.eu-west-1.amazonaws.com/dev/ListCategories",
//   EDIT_TENDER:
//     "https://3ldx476lsa.execute-api.eu-west-1.amazonaws.com/dev/edit",
//   DELETE_TENDER:
//     "https://3ldx476lsa.execute-api.eu-west-1.amazonaws.com/dev/delete",
//   UPDATE_TENDER_FILE:
//     "https://3ldx476lsa.execute-api.eu-west-1.amazonaws.com/dev/updatefile",
//   ASSIGN_TENDER:
//     "https://3ldx476lsa.execute-api.eu-west-1.amazonaws.com/dev/assign",
//   REMOVE_USER_TENDER:
//     "https://3ldx476lsa.execute-api.eu-west-1.amazonaws.com/dev/remove",
//   INVITE_BIDDER:
//     "https://3ldx476lsa.execute-api.eu-west-1.amazonaws.com/dev/invite",
//   BIDDER_DECLINE:
//     "https://3ldx476lsa.execute-api.eu-west-1.amazonaws.com/dev/decline",
//   UPDATE_MESSAGE:
//     "https://3ldx476lsa.execute-api.eu-west-1.amazonaws.com/dev/updatemessage",
//   //Submission review
//   LIST_SUBMISSIONS:
//     "https://3mts41nmph.execute-api.eu-west-1.amazonaws.com/dev/listsubmissions",
//   GET_SUBMISSION:
//     "https://3mts41nmph.execute-api.eu-west-1.amazonaws.com/dev/getsubmission",
//   GET_SUBMISSION_FILE:
//     "https://3mts41nmph.execute-api.eu-west-1.amazonaws.com/dev/getsubmissionfile",
//   //Reporting
//   ACCESS_LOGS:
//     "https://o1xkilyr0j.execute-api.eu-west-1.amazonaws.com/dev/accesslogs",
//   SUBMISSION_REPORT:
//     "https://o1xkilyr0j.execute-api.eu-west-1.amazonaws.com/dev/submissionreport",
//   // Websocket
//   WEBSOCKET: 
//     "wss://lda5uunyp7.execute-api.eu-west-1.amazonaws.com/prod",
// };